export default __webpack_public_path__ + "static/media/ic-attempted.f79ccf93.svg";